import React, { useState, useEffect } from "react";
import logo from "../assets/logo.png";
import bgImage from "../assets/cover.jpg";
import { io } from "socket.io-client";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
// import { SOCKET_SERVER_IP, SOCKET_PORT } from "./config";
import { API_BASE } from "./config";

// const socket = io(`http://${SOCKET_SERVER_IP}:${SOCKET_PORT}`);
const socket = io(API_BASE, {
  transports: ["websocket"],
  secure: true,
});
export default function Home() {
  const [time, setTime] = useState(new Date());
  const [attendance, setAttendance] = useState(null);
  const navigate = useNavigate();

  const officeStart = "08:00";
  const officeEnd = "17:00";

  // ⏰ Update jam real-time
  useEffect(() => {
    const interval = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  // 📡 Dengerin hasil scan dari server
  useEffect(() => {
    socket.on("tag_clockout", (data) => {
      console.log("📡 Data diterima dari server:", data);

      if (data.error) {
        Swal.fire({
          icon: "error",
          title: "Scan Gagal",
          text: data.error,
          confirmButtonColor: "#d33",
        });
        return;
      }

      setAttendance(data);

      const status = data?.status || ""; // fallback aman

      Swal.fire({
        icon:
          status.includes("Gagal") ||
          status.includes("Sudah") ||
          status.includes("Belum Tap") ||
          status.includes("UID Tidak Dikenal")
            ? "warning"
            : status === "Belum Waktu Pulang"
            ? "error"
            : "success",
        title: status || "Tidak Dikenal",
        html: `
          <b>${data.nama || "-"}</b><br/>
          Departemen: ${data.departemen || "-"}<br/>
          Lokasi: ${data.lokasi || "-"}<br/>
          ${data.waktu || "-"}
        `,
        timer: 3000,
        showConfirmButton: false,
      });
      

      // reset otomatis setelah 5 detik
      setTimeout(() => setAttendance(null), 5000);
    });

    return () => socket.off("tag_clockout");
  }, []);

  return (
    <div
      className="relative flex flex-col items-center justify-center min-h-screen"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      }}
    >
      <div className="absolute inset-0 bg-black/70"></div>
      <img
        src={logo}
        alt="SSD Logo"
        onClick={() => navigate("/")}
        className="h-12 absolute top-4 left-6 z-20 cursor-pointer"
      />

      <div className="relative z-10 text-center text-white p-6 w-full max-w-3xl">
        <h1 className="text-4xl font-bold mb-2">Sistem Absensi SSD</h1>
        <h1 className="text-4xl font-bold mb-2">Clock Out</h1>

        <div className="text-2xl font-semibold mb-6">
          {time.toLocaleTimeString()} <br />
          {time.toLocaleDateString("id-ID", {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
          })}
        </div>

        <div className="bg-white/90 text-black rounded-xl shadow-lg p-4 mb-6">
          <h2 className="text-xl font-bold mb-2">Jadwal Hari Ini</h2>
          <p>Masuk: {officeStart} WIB</p>
          <p>Pulang: {officeEnd} WIB</p>
        </div>

        {attendance && (
          <div className="mt-6 bg-white/95 text-black rounded-xl shadow-lg p-6">
            <h2 className="text-2xl font-bold mb-4">Clock Out</h2>
            <p>
              <strong>Nama:</strong> {attendance.nama || "-"}
            </p>
            <p>
              <strong>Departemen:</strong> {attendance.departemen || "-"}
            </p>
            <p>
              <strong>Lokasi:</strong> {attendance.lokasi || "-"}
            </p>
            <p>
              <strong>Waktu:</strong> {attendance.waktu || "-"}
            </p>
            <p
              className={`mt-4 font-bold text-xl ${
                (attendance?.status || "").includes("Terlambat")
                  ? "text-red-600"
                  : (attendance?.status || "").includes("Sudah")
                  ? "text-orange-600"
                  : (attendance?.status || "").includes("Gagal")
                  ? "text-gray-600"
                  : "text-green-600"
              }`}
            >
              {attendance?.status || "Status tidak tersedia"}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
